import axios from 'axios'
import i18next from 'i18next'

import Snackbar from 'components/Snackbar'

import { logApiException, logApiRequestFailed } from './sentryServices/logApiInfo'

export const showSnackbar = (
  isSuccess: boolean,
  content: string,
  options?: { duration?: number; preventDuplicate?: boolean },
) => {
  const snackbarOptions = {
    ...(options?.duration ? { autoHideDuration: options.duration } : {}),
    ...(options?.preventDuplicate ? { preventDuplicate: true } : {}),
  }

  if (isSuccess) {
    Snackbar.success(content, snackbarOptions)
  } else {
    Snackbar.error(content, snackbarOptions)
  }
}

export const showInfoSnackbar = (content: string, duration?: number) => {
  Snackbar.info(content, duration ? { autoHideDuration: duration } : undefined)
}

export const showApiFailedSnackbar = (message?: string, duration?: number) => {
  Snackbar.error(
    i18next.t('notifications.internal_server_error'),
    duration ? { autoHideDuration: duration } : undefined,
  )
  logApiRequestFailed(message ?? '')
}

export const showExceptionSnackbar = (error: unknown, duration?: number) => {
  if (axios.isAxiosError(error)) {
    Snackbar.error(
      i18next.t('notifications.internal_server_error'),
      duration ? { autoHideDuration: duration } : undefined,
    )
    logApiException(error)
  } else {
    Snackbar.error(
      i18next.t('notifications.network_error'),
      duration ? { autoHideDuration: duration } : undefined,
    )
  }
}
